import ArrowLeft from '@assets/icons/arrow-left.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { CompositeNavigationProp, RouteProp } from '@react-navigation/native';
import { EMPLOYEE_ROUTES, LOCATION_MANAGER_ROUTES } from '@/navigators/routes';
import {
  EmployeeStackParams,
  LocationManagerStackParams,
} from '@/navigators/types';
import { ModalContainer } from '@/components/modal-container';
import { PageContainer } from '@/components/page-container';
import { RestaurantEmployeeList } from '@/components/restaurant/restaurant-employee-list';
import { StackNavigationProp } from '@react-navigation/stack';
import { useRestaurantEmployees } from '@/hooks/use-restaurant-employees';

interface Props {
  navigation: CompositeNavigationProp<
    StackNavigationProp<EmployeeStackParams, EMPLOYEE_ROUTES.List>,
    StackNavigationProp<
      LocationManagerStackParams,
      LOCATION_MANAGER_ROUTES.ViewAccountEmployees
    >
  >;
  route:
    | RouteProp<EmployeeStackParams, EMPLOYEE_ROUTES.List>
    | RouteProp<
        LocationManagerStackParams,
        LOCATION_MANAGER_ROUTES.ViewAccountEmployees
      >;
}

export const RestaurantEmployeesScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const { restaurantName, restaurantUUID, supplierUUID } = route.params || {};
  const { restaurantEmployees, loading } = useRestaurantEmployees(
    restaurantUUID,
    supplierUUID,
  );
  return restaurantName && restaurantUUID && supplierUUID ? (
    <ModalContainer
      navigationHeaderProps={{
        BackButtonIcon: ArrowLeft,
        centerTitle: true,
        showBackButton: true,
        title: i18n.t('employees'),
      }}
    >
      <RestaurantEmployeeList
        loading={loading}
        onEmployeeSelect={(businessEmployee) => {
          navigation.navigate(LOCATION_MANAGER_ROUTES.ViewEmployeeDetail, {
            businessEmployee,
            restaurantName,
            restaurantUUID,
            supplierUUID,
            useModalContainer: true,
          });
        }}
        restaurantEmployees={restaurantEmployees}
        restaurantName={restaurantName}
        restaurantUUID={restaurantUUID}
        supplierUUID={supplierUUID}
      />
    </ModalContainer>
  ) : (
    <PageContainer
      navigationHeaderProps={{
        centerTitle: true,
        showBackButton: true,
        title: i18n.t('employees'),
      }}
    >
      <RestaurantEmployeeList
        loading={loading}
        onEmployeeSelect={(businessEmployee) => {
          navigation.navigate(EMPLOYEE_ROUTES.Detail, {
            businessEmployee,
            useModalContainer: false,
          });
        }}
        restaurantEmployees={restaurantEmployees}
      />
    </PageContainer>
  );
};
